import { InjectionToken } from '@angular/core';

/**
 * InjectionToken that holds the original URL hash captured in main.ts
 * BEFORE keycloak-js strips it via window.history.replaceState.
 *
 * This allows detecting whether the current page load is the result
 * of a Keycloak OIDC redirect (which includes state, session_state, code, iss in the hash).
 */

// declare global {
//     interface Window {
//         __KEYCLOAK_INITIAL_HASH__?: string;
//     }
// }

export const KEYCLOAK_INITIAL_HASH = new InjectionToken<string>('KEYCLOAK_INITIAL_HASH', {
    providedIn: 'root',
    factory: () => window.__KEYCLOAK_INITIAL_HASH__ || '',
});
